// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".UpgradePlanOnHover-clickOutside-1je4r {\n  display: inline-block;\n}\n.UpgradePlanOnHover-clickOutsideFullWidth-2VK7z {\n  display: block;\n}\n.UpgradePlanOnHover-DisabledPopoverText-2Tf7E {\n  color: #1a1a1a;\n  margin-bottom: 10px;\n  font-weight: normal;\n}\n", ""]);
// Exports
exports.locals = {
	"clickOutside": "UpgradePlanOnHover-clickOutside-1je4r",
	"clickOutsideFullWidth": "UpgradePlanOnHover-clickOutsideFullWidth-2VK7z",
	"DisabledPopoverText": "UpgradePlanOnHover-DisabledPopoverText-2Tf7E"
};
module.exports = exports;
